import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const BusinessRelationshipSection = ({ ...formProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="businessRelationshipSection"
      title={t('client.client.businessRelationship.title')}
    >
      <FormContent {...formProps} />
    </Section>
  );
};
